var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2571,
    cy: 18.2571,
    r: 18.2571,
    transform: "matrix(-1 0 0 1 36.5132 0)",
    fill: "#F5FAF5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2388,
    cy: 18.2397,
    r: 15.7397,
    stroke: "#0B5226",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.72 12V18.5917M18.72 25.1835V18.5917M18.72 18.5917H11.999M18.72 18.5917H25.441",
    stroke: "#0B5226",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ac3bac99c53bdd00dee3c50ac8282b12.svg";
export { ForwardRef as ReactComponent };